export default {
    print(params) {

        const page = window.open('', Math.random())

        var nomeExames = ''

        params.examesIncluidos.forEach(exame => {

            if (!nomeExames) {

                nomeExames = exame.nome
            } else {

                nomeExames = nomeExames + ', ' + exame.nome
            }
        })

        page.document.write(`
            <head>
                <title>Etiqueta</title>

                <style>
                    * {
                        font-family: 'Arial', 'Arial Bold', Gadget, sans-serif;
                    }
                    .content {
                        align-items: center;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                    }
                    .paper {
                        width: 8.3cm;
                    }
                    .container {
                        display: flex;
                        flex-direction: column;
                        padding: 0 0.1cm;
                    }
                    #header {
                        align-items: center;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                    }
                    #left-col {
                        flex-grow: 1;
                        padding-top:5px;
                    }
                    #right-col {
                        flex-grow: 1;
                        font-size: 0.3cm;
                        text-align: right;
                    }
                    h1 {
                        background-color: #000000;
                        color: #FFFFFF;
                        font-size: 0.25cm;
                        margin: 0;
                        padding: 0.25cm;
                        text-align: center;
                    }
                    p {
                        font-size: 0.25cm;
                        margin: 0.08cm 0;
                        padding: 0;
                    }
                </style>
            </head>

            <body>
                <div class="content">
                    <div class="paper">
                        <h1>${params.paciente}</h1>
                        <div class="container">
                            <div id="header">
                                <div id="left-col">
                                    <p><strong>DATA NASCIMENTO:</strong> ${params.dataNascimento}</p>
                                    <p><strong>NR. AGENDAMENTO:</strong> ${params.numeroAgendamento}</p>
                                    <p><strong>MÉDICO:</strong> ${params.medicoSolicitante}</p>
                                    <p><strong>UNIDADE:</strong> ${params.unidadeExecutante}</p>
                                    <p><strong>DATA EXAME:</strong> ${params.dataExame}</p>
                                    <p><strong>EXAMES:</strong> ${nomeExames}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        `)
        page.print()
        page.close()
    }
}